import {Barcode, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalAddBarcode} from "./PortalAddBarcode";

export class PortalBarcode extends Barcode implements Parameter {
	constructor(data: any) {
		super(data);

		this.add = PortalAddBarcode.fromJson(data?.add);
	}

	public static fromJson(data: any): PortalBarcode {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalBarcode(data);
	}

	public clone(): PortalBarcode {
		return PortalBarcode.fromJson(this.toJson());
	}
}